import * as Yup from 'yup';
import {yupStringMin} from '../../../../functions/validationsYup';

export const getPricingValidationSchema = (globalT: (key: string) => string) => {
    return Yup.object().shape({
        name: yupStringMin().required(globalT('errorRequired')),
        price: Yup.number().required(globalT('errorRequired')).positive(globalT('errorNumber')),
        ticketsAmount: Yup.string().required(globalT('errorRequired')),
        manualTicketsAmount: Yup.string().when('ticketsAmount', {
            is: 0,
            then: (schema) => schema
                .required(globalT('errorRequired'))
        })
    });
};

